import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

const CTASection = () => {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 bg-primary relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="cta-grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="0.5"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#cta-grid)" />
        </svg>
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h2 className="text-5xl md:text-6xl font-poppins font-black text-white mb-6">
            Ready to Start Your Project?
          </h2>
          <p className="text-white/80 font-inter text-xl mb-10 leading-relaxed">
            Get in touch with our team today for a free consultation and quote. 
            Let's build something extraordinary together.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <button
              onClick={scrollToContact}
              className="px-10 py-5 bg-accent text-white rounded-full font-inter font-bold text-base hover:bg-accent-dark transition-all duration-300 shadow-2xl hover:shadow-accent/50 flex items-center gap-3 cursor-pointer whitespace-nowrap"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-line text-xl"></i>
              </div>
              Contact Us Now
            </button>

            <a
              href="tel:+966501234567"
              className="px-10 py-5 bg-white/10 backdrop-blur-sm text-white rounded-full font-inter font-bold text-base border-2 border-white hover:bg-white hover:text-primary transition-all duration-300 flex items-center gap-3 cursor-pointer whitespace-nowrap"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-fill text-xl"></i>
              </div>
              +966 50 123 4567
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
